import { axiosInstance, useApi } from '@fides/fides-react-components';
import { AxiosError, AxiosResponse } from 'axios';
import { TableParams } from 'core/interfaces/TableParams';
import { endpoints } from '../consts';
import { DebitParams, VersionInformation } from '../interfaces';
import { Currency } from '../models';

export const getEFT = (restUrl: string, params: TableParams | DebitParams): Promise<AxiosResponse> =>
  axiosInstance.get(restUrl, { baseURL: endpoints.EFTApiUrl, params });

const CACHE_TTL_MS = 5 * 1000;

interface CacheEntry {
  promise: Promise<AxiosResponse>;
  expireAt: number;
}

const eftCache = new Map<string, CacheEntry>();

export const getEFTDeduped = (restUrl: string, params: TableParams | DebitParams): Promise<AxiosResponse> => {
  const key = `${restUrl}::${JSON.stringify(params)}`;
  const cached = eftCache.get(key);

  if (cached !== undefined && Date.now() < cached.expireAt) {
    return cached.promise;
  }

  eftCache.delete(key);

  const promise = axiosInstance.get(restUrl, { baseURL: endpoints.EFTApiUrl, params }).catch((error: AxiosError) => {
    eftCache.delete(key);
    throw error;
  });

  eftCache.set(key, { promise, expireAt: Date.now() + CACHE_TTL_MS });
  return promise;
};

export const getCurrencies = (): Promise<Currency[]> =>
  axiosInstance
    .get(`${endpoints.ARSApiUrl}/${endpoints.currencies}`)
    .then((response: AxiosResponse<Currency[]>) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });

export const useFetchVersionInfo = (): VersionInformation => {
  const [response] = useApi<VersionInformation>({
    baseURL: endpoints.PortalApiUrl,
    url: endpoints.versionInformation,
  });
  return response.data;
};
